<template lang="pug">
div
  h4.warning {{$t('Monitors')}}
    el-button.float-right(v-if='isAdminOrSuperAdmin', type='success', size="mini", @click='showNewMonitorForm()', id="EditMonitorsDesktops-showAddNewMonitor")
      font-awesome-icon(icon="plus")
  .row.header(v-if='newEditedDevice.DeviceMonitors.length > 0')
    .cell.monitor {{ $t('name') }}
    .cell.monitor {{ $t('row') }}
    .cell.monitor {{ $t('column') }}
    .cell.monitor {{ $t('width') }}
    .cell.monitor {{ $t('height') }}
    .cell.monitor {{ $t('LED') }}
    .cell.monitor
  .row(v-for='monitor of newEditedDevice.DeviceMonitors', :key='monitor.id', :id="'EditMonitorsDesktops-monitorRow' + monitor.id")
    .cell.monitor {{ monitor.name }}
    .cell.monitor {{ monitor.row }}
    .cell.monitor {{ monitor.column }}
    .cell.monitor {{ monitor.width }}
    .cell.monitor {{ monitor.height }}
    .cell.monitor
      span(v-if='monitor.led && monitor.LedPitch && ledPitches') {{ ledPitches.find(p => p.id === monitor.LedPitch).name }}
    .cell.monitor.button
      el-button(v-if='isAdminOrSuperAdmin', @click='deleteMonitor(monitor)', type='success', size='mini', :id="'EditMonitorsDesktops-deleteMonitorButton' + monitor.id")
        font-awesome-icon(icon="trash")
      el-button(@click='addEditMonitorFormVisible = true; newEditedMonitor = monitor;', type='success', size='mini', :id="'EditMonitorsDesktops-editMonitorButton' + monitor.id")
        font-awesome-icon(icon="edit")
  p(v-if="newEditedDevice.DeviceMonitors.length === 0") {{ $t('Device has no monitors defined. If device has some monitors attached, please define them here.')}}
  .headless(v-if='deviceDesktopsHeadless.length > 0')
    p
      span {{ $t('UUID') }}:&nbsp;
      span {{ deviceDesktopsHeadless[0].uuid ? deviceDesktopsHeadless[0].uuid : $t('No uuid...') }} &nbsp; &nbsp;
      el-button.float-right(id="EditMonitorsDesktops-showEditSingleDesktop" @click='editDesktopFormVisible = true; editedDesktop = deviceDesktopsHeadless[0];', type='success', size='mini')
        font-awesome-icon(icon="edit")
  .createButtons(v-if="newEditedDevice.DeviceMonitors.length > 0")
    el-button(id="EditMonitorsDesktops-createSingleOrWallButton" type='success', size="mini", @click='createDesktop("concat")')
      span(v-if="newEditedDevice.DeviceMonitors.length === 1") {{$t('Create one Desktop')}} &nbsp;
        font-awesome-icon(icon="desktop")
      span(v-if="newEditedDevice.DeviceMonitors.length > 1") {{$t('Concate monitors and create Video Wall')}} &nbsp;
        font-awesome-icon(icon="th")
    span(v-if="newEditedDevice.DeviceMonitors.length > 1") &nbsp; {{$t('or')}} &nbsp;
    el-button(id="EditMonitorsDesktop-createSeparateButton" v-if="newEditedDevice.DeviceMonitors.length > 1", type='success', size="mini", @click='createDesktop("divide")')
      span {{$t(`Create ${newEditedDevice.DeviceMonitors.length} separate Desktops`)}}
      span(v-for="monitor in newEditedDevice.DeviceMonitors.length", :key="monitor.id") &nbsp;
        font-awesome-icon(icon="desktop")
    p.create-desktops-description(v-if='(deviceDesktops && deviceDesktops.length > 0) && (newEditedDevice.DeviceMonitors.length > 0)')
      p.create-desktops-description {{ $t('Existing desktops will be purged from the database. You will have to edit new desktops UUIDs and re-assign media to them.')}}
      p.create-desktops-description {{ $t('No media will be deleted.')}}
  div(v-if='deviceDesktops && deviceDesktops.length > 0')
    h4.warning {{$t('Desktops')}}
    .row.header(v-if='deviceDesktops.length > 0')
      .cell.desktop {{ $t('name') }}
      .cell.desktop {{ $t('width') }}
      .cell.desktop {{ $t('height') }}
      .cell.desktop {{ $t('uuid') }}
      .cell.desktop {{ $t('location') }}
      .cell.desktop
    .row(v-for='deviceDesktop of deviceDesktops', :key='deviceDesktop.id')
      .cell.desktop {{ deviceDesktop.name }}
      .cell.desktop {{ deviceDesktop.width }}
      .cell.desktop {{ deviceDesktop.height }}
      .cell.desktop.selectable.uuid-input(:title="deviceDesktop.uuid") {{ deviceDesktop.uuid }}
      .cell.desktop {{ deviceDesktop.DeviceDesktopGroup ? getGroupFromDesktop(deviceDesktop).name : '-' }}
      .cell.desktop.button
        el-button(:id="'EditMonitorsDesktops-editDesktop'+deviceDesktop.id", @click='editDesktopFormVisible = true; editedDesktop = deviceDesktop;', type='success', size='mini')
          font-awesome-icon(icon="edit")
  el-dialog(:close-on-click-modal="false", :visible.sync='editDesktopFormVisible', append-to-body, @close='closeEditDesktopForm()')
    h4(v-if='editedDesktop.name !== "headless"') {{$t('Change desktop')}} - {{editedDesktop.name}} {{editedDesktop.width}} x {{editedDesktop.height}}
      hr.header
    el-form(:model='editedDesktop', label-width="120px", v-on:submit.native.prevent='saveDesktop()')
      el-form-item(v-if='editedDesktop.name !== "headless"', :label="$t('Name')")
        el-input(id="EditMonitorsDesktops-desktopNameInput", :placeholder='$t("name")', v-model='editedDesktop.name', label='name')
      el-form-item(:label="$t('UUID')")
        el-input(id="EditMonitorsDesktops-desktopUUIDInput", :placeholder='$t("uuid")', ref="uuid", v-model='editedDesktop.uuid', label='uuid')
      el-form-item(v-if='editedDesktop.name !== "headless"', :label="$t('Width (px)')")
        el-input-number(id="EditMonitorsDesktops-widthInput", v-model='editedDesktop.width', controls-position="right", :min="100", :max="10000")
      el-form-item(v-if='editedDesktop.name !== "headless"', :label="$t('Height (px)')")
        el-input-number(id="EditMonitorsDesktops-heightInput", v-model='editedDesktop.height', controls-position="right", :min="100", :max="10000")
      el-form-item(:label="$t('')", v-if='uniqueUUIDerror')
        span.warning(id="EditMonitorsDesktops-duplicateUUIDWarning") {{ $t('Save failed! Another desktop in Wave2 has this UUID already!') }}
      el-button.float-right(id="EditMonitorsDesktops-saveDesktopButton", type='success', size="mini", @click='saveDesktop()')
        font-awesome-icon(icon="save")
        span &nbsp;{{ $t('Update desktop')}}
  el-dialog(:close-on-click-modal="false", :visible.sync='addEditMonitorFormVisible', append-to-body, @close='closeNewMonitorForm()')
    h4 {{$t(`${!newEditedMonitor.id ? 'Add' : 'Edit'} monitor`)}}
      hr.header
    el-form(:model='newEditedMonitor', label-width="120px", v-on:submit.native.prevent='createEditMonitor(newEditedMonitor.id)')
      el-form-item(:label="$t('Name')")
        el-input(id="EditMonitorsDesktops-monitorNameInput", :placeholder='$t("name")', v-model='newEditedMonitor.name')
      el-form-item(:label="$t('Row (A-Z)')")
        el-input(id="EditMonitorsDesktops-monitorRowInput", style="width:100px", v-model='newEditedMonitor.row')
      el-form-item(:label="$t('Column (1-10)')")
        el-input-number(id="EditMonitorsDesktops-monitorColumnInput", v-model='newEditedMonitor.column', controls-position="right", :min="1", :max="10")
      el-form-item(:label="$t('Width (px)')")
        el-input-number(id="EditMonitorsDesktops-monitorWidthInput", v-model='newEditedMonitor.width', controls-position="right", :min="100", :max="10000")
      el-form-item(:label="$t('Height (px)')")
        el-input-number(id="EditMonitorsDesktops-monitorHeightInput", v-model='newEditedMonitor.height', controls-position="right", :min="100", :max="10000")
      el-form-item(:label="$t('LED')")
        el-checkbox(id="EditMonitorsDesktops-monitorLEDCheckbox", v-model="newEditedMonitor.led")
        span(v-if='newEditedMonitor.led') &nbsp; {{ newEditedMonitor.LedPitch > 0 ? ledPitches.find(p => p.id === newEditedMonitor.LedPitch).name : $t('choose pitch:') }}
        el-dropdown(id="EditMonitorsDesktops-monitorLEDDropdown", v-if='newEditedMonitor.led', @command='changePitch')
          span.el-dropdown-link
            i.el-icon-arrow-down.el-icon--right
          el-dropdown-menu(slot='dropdown')
            el-dropdown-item(v-for='ledPitch of ledPitches', :id="'EditMonitorsDesktops-monitorLEDOption' + ledPitch.id", :key='ledPitch.id', :command='ledPitch.id') {{ ledPitch.name }}
      el-button.float-right(id="EditMonitorsDesktops-monitorSaveButton", type='success', size="mini", @click='createEditMonitor(newEditedMonitor.id)')
        span {{ $t(`${!newEditedMonitor.id ? $t('Add') : $t('Save')} ${$t('monitor')}`)}}
</template>

<script>
import Vue from 'vue'
import deviceUtilsMixin from '../Common/deviceUtils.mixin'
import userUtilsMixin from '../Common/userUtils.mixin'

export default {
  props: ['side', 'newEditedDevice'],
  mixins: [deviceUtilsMixin, userUtilsMixin],
  async created () {
    this.ledPitches = (await Vue.axios.get('ledpitch?populate=false')).data
  },
  data () {
    return {
      uniqueUUIDerror: false,
      addEditMonitorFormVisible: false,
      newEditedMonitor: {
        width: 1920,
        height: 1080
      },
      editedDesktop: { name: '' },
      editDesktopFormVisible: false,
      ledPitches: null
    }
  },
  methods: {
    async deleteMonitor (monitor) {
      await Vue.axios.delete('deviceMonitor/' + monitor.id)
      this.$emit('reloadDevice')
    },
    async saveDesktop () {
      await Vue.axios
        .patch(`deviceDesktop/${this.editedDesktop.id}`, this.editedDesktop, { disableResponseInterceptors: true })
        .then(response => {
          this.editDesktopFormVisible = false
          this.uniqueUUIDerror = false
          this.$emit('reloadDevice')
        })
        .catch(error => {
          if (error.response.data.code === 'E_UNIQUE') {
            this.uniqueUUIDerror = true
          } else {
            this.$store.dispatch('Error/setAxiosError', error.response)
          }
        })
    },
    changePitch (value) {
      this.newEditedMonitor.LedPitch = value
    },
    showNewMonitorForm () {
      this.addEditMonitorFormVisible = true
    },
    closeNewMonitorForm () {
      this.addEditMonitorFormVisible = false
      this.$emit('reloadDevice')
    },
    closeEditDesktopForm () {
      this.editDesktopFormVisible = false
      this.$emit('reloadDevice')
    },
    async createDesktop (mode) {
      await Vue.axios
        .post('device/createDeviceDesktops', { device: this.newEditedDevice.id, mode: mode })
        .then(response => {
          this.$store.dispatch('Device/updateDesktops', response.data)
        })
      this.$emit('reloadDevice')
    },
    async createEditMonitor () {
      this.newEditedMonitor.Device = this.newEditedDevice.id
      if (this.newEditedMonitor.Device && !this.newEditedMonitor.id) {
        await Vue.axios.post('deviceMonitor', this.newEditedMonitor)
      } else if (this.newEditedMonitor.Device && this.newEditedMonitor.id) {
        await Vue.axios.patch(`deviceMonitor/${this.newEditedMonitor.id}`, this.newEditedMonitor)
      }
      this.$emit('reloadDevice')
    }
  },
  computed: {
    devices () {
      return this.$store.state.Device.device_list
    },
    deviceDesktops () {
      return this.newEditedDevice.DeviceDesktops.filter(dd => dd.name !== 'headless')
    },
    deviceDesktopsHeadless () {
      return this.newEditedDevice.DeviceDesktops.filter(dd => dd.name === 'headless')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.createButtons {
  text-align: center;
  margin: 30px;
  .create-desktops-description {
    color: $--color-text-secondary;
  }
}
.row {
  display: flex;
  border-bottom:  $--border-light;
  align-items: center;
  &.header {
    opacity: 0.5;
    padding-bottom: 5px;
  }
  .cell {
    width: 20%;
    &.button {
      text-align: right;
    }
    &.desktop {
      overflow: hidden;
    }
  }
}
.uuid-input {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/EditMonitorsDesktops.vue